import defineMessages from "../../../common/helpers/defineMessages";

const messages = defineMessages({
    tonesetSolfa: {
        id: "meta.toneset.solfa",
    },
    rhythmPatterns: {
        id: "meta.rhythmPatterns",
    },
    intervals: {
        id: "meta.intervals",
    },
    range: {
        id: "meta.range",
    },
    rangeInterval: {
        id: "meta.range.interval",
    },
    isUpbeat: {
        id: "meta.isUpbeat",
    },
    articleTitle: {
        id: "article.filters.title",
    },
    articleDescription: {
        id: "article.filters.description",
    },
    articleRhythmTitle: {
        id: "article.filters.rhythm.title",
    },
    articleRhythmDescription: {
        id: "article.filters.rhythm.description",
    },
    articlePitchTitle: {
        id: "article.filters.pitch.title",
    },
    articlePitchDescription: {
        id: "article.filters.pitch.description",
    },
});

export default messages;
